import palette from "../palette";

export default {
  popupIndicator: {
    color: palette.icon,
  },
  clearIndicator: {
    color: palette.icon,
  },
};
